import type { QuizDataType } from '../../flowTypes'
import { DipseaContentfulAssets } from '../shared'

const QUIZ_ICONS = Object.freeze({
  wine: '/images/wine-glass.png',
  lips: '/images/lips.png',
  envelope: '/images/envelope.png',
  chat: '/images/chat-bubbles.png',
  thought: '/images/thought-bubble.png',
  heart: '/images/heart-outline-icon.png',
  star: '/images/star.png',
  mic: '/images/mic-icon.png',
  couple: '/images/couple-icon.png',
  flame: '/images/flame-icon.png'
})

// The order here, determines the rank of the hunk if the is no tiebreaker
// ie: Malcolm vs Jack; has no tiebreakder, Malcolm is higher and will get returned
export const HUNK = Object.freeze({
  a: 'Malcolm',
  b: 'Charli',
  c: 'Jack',
  d: 'Cecelia',
  e: 'James',
  f: 'Jennifer'
})

// The order here, determines the rank of the series if the is no tiebreaker
// ie: 'The Local' vs 'Hometown'; has no tiebreakder, 'The Local' is higher and will get returned
export const TROPE = Object.freeze({
  a: 'The Local',
  b: 'Playing the Field',
  c: 'Hometown',
  d: 'The Tradition',
  e: 'Lecture Me',
  f: 'The Figure'
})

// The order here, determines the rank of the series if the is no tiebreaker
export const FANTASY = Object.freeze({
  a: 'Forbidden Fruit',
  b: 'Close Companions',
  c: 'Courted',
  d: 'Night School'
})

export const hunkQuizCopy: Readonly<QuizDataType> = Object.freeze<QuizDataType>({
  quiz: [
    {
      index: 0,
      icon: QUIZ_ICONS.wine,
      iconAlt: 'wine icon',
      questionText: "On the first date, I'd like someone to...",
      answers: [
        {
          index: 0,
          text: "Plan it all, I'm just along for the ride",
          outcomes: [HUNK.a, HUNK.b]
        },
        {
          index: 1,
          text: "Follow my lead, I'm in control",
          outcomes: [HUNK.c, HUNK.d]
        },
        {
          index: 2,
          text: 'Pick the spot, then let me run the show',
          outcomes: [HUNK.e, HUNK.f]
        }
      ]
    },
    {
      index: 1,
      icon: QUIZ_ICONS.lips,
      iconAlt: 'lips icon',
      questionText: 'I want someone to kiss me...',
      answers: [
        {
          index: 0,
          text: "Passionately, like they can't get enough",
          outcomes: [HUNK.a, HUNK.b]
        },
        {
          index: 1,
          text: 'Gently, with a smile on their face',
          outcomes: [HUNK.c, HUNK.d]
        },
        {
          index: 2,
          text: "Secretly, like it's something just for us",
          outcomes: [HUNK.e, HUNK.f]
        }
      ]
    },
    {
      index: 2,
      icon: QUIZ_ICONS.envelope,
      iconAlt: 'envelope icon',
      questionText: 'Please send...',
      answers: [
        {
          index: 0,
          text: 'Nudes',
          outcomes: [HUNK.a, HUNK.b]
        },
        {
          index: 1,
          text: 'Flowers',
          outcomes: [HUNK.c, HUNK.d]
        },
        {
          index: 2,
          text: 'A sexy voice note',
          outcomes: [HUNK.e, HUNK.f]
        }
      ]
    },
    {
      index: 3,
      icon: QUIZ_ICONS.chat,
      iconAlt: 'chat icon',
      questionText: 'Flirt with me like this...',
      answers: [
        {
          index: 0,
          text: 'Say exactly what you want',
          outcomes: [HUNK.a, HUNK.b]
        },
        {
          index: 1,
          text: 'Make me laugh',
          outcomes: [HUNK.c, HUNK.d]
        },
        {
          index: 2,
          text: 'Keep me on my toes',
          outcomes: [HUNK.e, HUNK.f]
        }
      ]
    },
    {
      index: 4,
      icon: QUIZ_ICONS.thought,
      iconAlt: 'thought icon',
      questionText: "I'm more of a...",
      answers: [
        {
          index: 0,
          text: 'Rule breaker',
          outcomes: [HUNK.a, HUNK.b]
        },
        {
          index: 1,
          text: 'Hopeless romantic',
          outcomes: [HUNK.c, HUNK.d]
        },
        {
          index: 2,
          text: 'People pleaser',
          outcomes: [HUNK.e, HUNK.f]
        }
      ]
    },
    {
      index: 5,
      icon: QUIZ_ICONS.heart,
      iconAlt: 'heart icon',
      questionText: "I'm interested in...",
      genderPref: true,
      answers: [
        {
          index: 0,
          text: 'Men',
          genderPrefText: 'Men',
          outcomes: [HUNK.a, HUNK.c, HUNK.e]
        },
        {
          index: 1,
          text: 'Women',
          genderPrefText: 'Women',
          outcomes: [HUNK.b, HUNK.d, HUNK.f]
        },
        {
          index: 2,
          text: 'Both',
          genderPrefText: 'Both',
          outcomes: [HUNK.a, HUNK.c, HUNK.e, HUNK.b, HUNK.d, HUNK.f]
        }
      ]
    }
  ],
  tieBreakers: [
    {
      index: 0,
      type: 'tiebreaker',
      icon: QUIZ_ICONS.star,
      iconAlt: 'star icon',
      questionText: "I'm into hunks who...",
      vs: [HUNK.a, HUNK.b],
      answers: [
        {
          index: 0,
          text: 'Live in the city',
          outcomes: [HUNK.a]
        },
        {
          index: 1,
          text: 'Live in the country',
          outcomes: [HUNK.b]
        }
      ]
    },
    {
      index: 1,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: "I'm into hunks who...",
      vs: [HUNK.a, HUNK.b, HUNK.c, HUNK.d],
      answers: [
        {
          index: 0,
          text: 'Live in the city',
          outcomes: [HUNK.a]
        },
        {
          index: 1,
          text: 'Live in the country',
          outcomes: [HUNK.b]
        }
      ]
    },
    {
      index: 2,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: "I'm into hunks who are...",
      vs: [HUNK.a, HUNK.b, HUNK.e, HUNK.f],
      answers: [
        {
          index: 0,
          text: 'Live in the city',
          outcomes: [HUNK.a]
        },
        {
          index: 1,
          text: 'Live in the country',
          outcomes: [HUNK.b]
        }
      ]
    },
    {
      index: 3,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: "I'm into hunks with...",
      vs: [HUNK.c, HUNK.d],
      answers: [
        {
          index: 0,
          text: 'British accents',
          outcomes: [HUNK.c]
        },
        {
          index: 1,
          text: 'French accents',
          outcomes: [HUNK.d]
        }
      ]
    },
    {
      index: 4,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: "I'm into hunks with...",
      vs: [HUNK.c, HUNK.d, HUNK.e, HUNK.f],
      answers: [
        {
          index: 0,
          text: 'British accents',
          outcomes: [HUNK.c]
        },
        {
          index: 1,
          text: 'French accents',
          outcomes: [HUNK.d]
        }
      ]
    },
    {
      index: 5,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: "I'm into hunks who are...",
      vs: [HUNK.e, HUNK.f],
      answers: [
        {
          index: 0,
          text: 'Nerds with a secret freaky side',
          outcomes: [HUNK.e]
        },
        {
          index: 1,
          text: 'Sophisticated, intellectual types',
          outcomes: [HUNK.f]
        }
      ]
    }
  ],
  results: {
    [HUNK.a]: {
      id: '-LMda6LocG6OnMa7SQlt',
      image: DipseaContentfulAssets.quiz_hunk_malcolm,
      genderPref: 'Men',
      display_name: HUNK.a,
      description: 'A fashion designer who usually plays games but is ready to fall in love'
    },
    [HUNK.b]: {
      id: '-MveBYUuKoHMcGvCcOOK',
      image: DipseaContentfulAssets.quiz_hunk_charli,
      genderPref: 'Women',
      display_name: HUNK.b,
      description: 'A no-nonsense cowgirl who’s always ready to ride'
    },
    [HUNK.c]: {
      id: '-Mag5Ok9D2YGIUs2hBCE',
      image: DipseaContentfulAssets.quiz_hunk_jack,
      genderPref: 'Men',
      display_name: HUNK.c,
      description: 'A broody hometown crush with a secret sensitive side'
    },
    [HUNK.d]: {
      id: '-N0rPTmKGNRYYKWDUtdG',
      image: DipseaContentfulAssets.quiz_hunk_cecelia,
      genderPref: 'Women',
      display_name: HUNK.d,
      description: 'A dreamy sculptor who does more than mold with her hands'
    },
    [HUNK.e]: {
      id: '-MWUjKAvlyN3387qbogd',
      image: DipseaContentfulAssets.quiz_hunk_james,
      genderPref: 'Men',
      display_name: HUNK.e,
      description: 'A college professor who’s not afraid to break the rules and let loose'
    },
    [HUNK.f]: {
      id: '-MWUkLCY33d3UPVHuLtz',
      image: DipseaContentfulAssets.quiz_hunk_jennifer,
      genderPref: 'Women',
      display_name: HUNK.f,
      description: 'A dynamic professor with great style who doesn’t back down'
    }
  },
  resultHeader: 'Your Perfect Match Is...',
  resultSlides: [
    {
      text: 'Hundreds of Sexy audio stories',
      image: '/images/loading-slide-1.png'
    },
    {
      text: 'Sleep stories and sounds',
      image: '/images/loading-slide-2.png'
    },
    {
      text: 'Intimate wellness guides',
      image: '/images/loading-slide-3.png'
    }
  ]
})

export const tropeQuizCopy: Readonly<QuizDataType> = Object.freeze<QuizDataType>({
  quiz: [
    {
      index: 0,
      icon: QUIZ_ICONS.couple,
      iconAlt: 'couple icon',
      questionText: 'Which pair is couple goals?',
      answers: [
        {
          index: 0,
          text: `Kate & Anthony in "Bridgerton"`,
          outcomes: [TROPE.a, TROPE.b]
        },
        {
          index: 1,
          text: `Pam & Jim in "The Office"`,
          outcomes: [TROPE.c, TROPE.d]
        },
        {
          index: 2,
          text: `Fleabag and Hot Priest in "Fleabag"`,
          outcomes: [TROPE.e, TROPE.f]
        }
      ]
    },
    {
      index: 1,
      icon: QUIZ_ICONS.mic,
      iconAlt: 'microphone icon',
      questionText: `What's your karaoke song of choice?`,
      answers: [
        {
          index: 0,
          text: `"Bad Guy" by Billie Eilish `,
          outcomes: [TROPE.a, TROPE.b]
        },
        {
          index: 1,
          text: `"Kiss Me More" by Doja Cat`,
          outcomes: [TROPE.c, TROPE.d]
        },
        {
          index: 2,
          text: `"Call Your Girlfriend" by Robyn`,
          outcomes: [TROPE.e, TROPE.f]
        }
      ]
    },
    {
      index: 2,
      icon: QUIZ_ICONS.lips,
      iconAlt: 'lips icon',
      questionText: 'Which character makes you swoon?',
      answers: [
        {
          index: 0,
          text: `Jon Snow in "Game of Thrones"`,
          outcomes: [TROPE.a, TROPE.b]
        },
        {
          index: 1,
          text: `Nick in "New Girl"`,
          outcomes: [TROPE.c, TROPE.d]
        },
        {
          index: 2,
          text: `Gabriel in "Emily in Paris"`,
          outcomes: [TROPE.e, TROPE.f]
        }
      ]
    },
    {
      index: 3,
      icon: QUIZ_ICONS.chat,
      iconAlt: 'chat icon',
      questionText: 'When I’ve got a crush I...',
      answers: [
        {
          index: 0,
          text: 'Make fun of them',
          outcomes: [TROPE.a, TROPE.b]
        },
        {
          index: 1,
          text: 'Invite them out with friends',
          outcomes: [TROPE.c, TROPE.d]
        },
        {
          index: 2,
          text: 'Respond to their Instagram story',
          outcomes: [TROPE.e, TROPE.f]
        }
      ]
    },
    {
      index: 4,
      icon: QUIZ_ICONS.flame,
      iconAlt: 'flame icon',
      questionText: 'I know there’s a spark when…',
      answers: [
        {
          index: 0,
          text: 'The sarcastic banter is flowing',
          outcomes: [TROPE.a, TROPE.b]
        },
        {
          index: 1,
          text: 'I feel truly seen',
          outcomes: [TROPE.c, TROPE.d]
        },
        {
          index: 2,
          text: 'We have to keep it a secret',
          outcomes: [TROPE.e, TROPE.f]
        }
      ]
    },
    {
      index: 5,
      icon: QUIZ_ICONS.heart,
      iconAlt: 'heart icon',
      questionText: "I'm interested in...",
      genderPref: true,
      answers: [
        {
          index: 0,
          text: 'Men',
          genderPrefText: 'Men',
          outcomes: [TROPE.a, TROPE.c, TROPE.e]
        },
        {
          index: 1,
          text: 'Women',
          genderPrefText: 'Women',
          outcomes: [TROPE.b, TROPE.d, TROPE.f]
        },
        {
          index: 2,
          text: 'Both',
          genderPrefText: 'Both',
          outcomes: [TROPE.a, TROPE.c, TROPE.e, TROPE.b, TROPE.d, TROPE.f]
        }
      ]
    }
  ],
  tieBreakers: [
    {
      index: 0,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'I’m into stories...',
      vs: [TROPE.a, TROPE.b],
      answers: [
        {
          index: 0,
          text: 'With Irish characters',
          outcomes: [TROPE.a]
        },
        {
          index: 1,
          text: 'With athletic characters',
          outcomes: [TROPE.b]
        }
      ]
    },
    {
      index: 1,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'I’m into stories...',
      vs: [TROPE.a, TROPE.b, TROPE.c, TROPE.d],
      answers: [
        {
          index: 0,
          text: 'With Irish characters',
          outcomes: [TROPE.a]
        },
        {
          index: 1,
          text: 'With athletic characters',
          outcomes: [TROPE.b]
        }
      ]
    },
    {
      index: 2,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'I’m into stories...',
      vs: [TROPE.a, TROPE.b, TROPE.e, TROPE.f],
      answers: [
        {
          index: 0,
          text: 'With Irish characters',
          outcomes: [TROPE.a]
        },
        {
          index: 1,
          text: 'With athletic characters',
          outcomes: [TROPE.b]
        }
      ]
    },
    {
      index: 3,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'I’m into stories...',
      vs: [TROPE.c, TROPE.d],
      answers: [
        {
          index: 0,
          text: 'With brooding, artistic characters',
          outcomes: [TROPE.c]
        },
        {
          index: 1,
          text: 'With goofy, down to earth characters',
          outcomes: [TROPE.d]
        }
      ]
    },
    {
      index: 4,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'I’m into stories...',
      vs: [TROPE.c, TROPE.d, TROPE.e, TROPE.f],
      answers: [
        {
          index: 0,
          text: 'With brooding, artistic characters',
          outcomes: [TROPE.c]
        },
        {
          index: 1,
          text: 'With goofy, down to earth characters',
          outcomes: [TROPE.d]
        }
      ]
    },
    {
      index: 5,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'I’m into stories...',
      vs: [TROPE.e, TROPE.f],
      answers: [
        {
          index: 0,
          text: 'That take place on campus',
          outcomes: [TROPE.e]
        },
        {
          index: 1,
          text: 'That take place in art studios',
          outcomes: [TROPE.f]
        }
      ]
    }
  ],
  results: {
    [TROPE.a]: {
      id: '-MoG57gBRkL4rXgDdGa_',
      image: DipseaContentfulAssets.quiz_trope_the_local,
      genderPref: 'Men',
      display_name: TROPE.a,
      description: 'When grad student Sabrina moves into the flat above Killian’s pub, the two are bound to butt heads. Sabrina is serious and studious; Killian is cheeky and charming–a typical, Irish rouge. Can these new neighbors learn to live together?'
    },
    [TROPE.b]: {
      id: '-MmKXJaY0O7AdJpgwPsP',
      image: DipseaContentfulAssets.quiz_trope_playing_the_field,
      genderPref: 'Women',
      display_name: TROPE.b,
      description: 'Pro soccer captain Ally isn’t exactly thrilled when talented newbie Julie joins the team. They both have an ego, leading to inevitable clashes on the field. But when Julie confronts Ally in the locker room, a new sort of tension emerges. Can these teammates learn to play nice?'
    },
    [TROPE.c]: {
      id: '-MV3TQcATVwpZhWK_wZJ',
      image: DipseaContentfulAssets.quiz_trope_hometown,
      genderPref: 'Men',
      display_name: TROPE.c,
      description: 'Gia was always drawn to Jack’s sensitive, artistic side in high school. But she never made a move, and they stayed firmly in each other’s friend zones. Ten years later, she moves back home and runs into Jack at a bar. Will their old friendship ignite into something more?'
    },
    [TROPE.d]: {
      id: '-MyJkZLt9jJDxls0oQK0',
      image: DipseaContentfulAssets.quiz_trope_the_tradition,
      genderPref: 'Women',
      display_name: TROPE.d,
      description: 'Kit and Anna have been friends forever. Their weekly TV nights normally involve sweatpants, playful banter, and junk food. But this week, the vibe feels different. When Kit offers to give Anna a massage, they both start to wonder: Could their friendship become something more?'
    },
    [TROPE.e]: {
      id: '-MCbZ0nwfE9FG_tmjcIK',
      image: DipseaContentfulAssets.quiz_trope_lecture_me,
      genderPref: 'Men',
      display_name: TROPE.e,
      description: 'When grad student Jane first attends Professor James’ class, she knows she’s in trouble. Their intellectual debates during office hours only increase the sexual tension between them. Finally, the semester ends, and Jane wonders: Will their forbidden attraction get to flourish?'
    },
    [TROPE.f]: {
      id: '-MtKOB744plPp9KkeriW',
      image: DipseaContentfulAssets.quiz_trope_the_figure,
      genderPref: 'Women',
      display_name: TROPE.f,
      description: 'Lev expects her artist’s residency on a remote island to be an adventure. But when she meets her sculpting instructor Cecelia, she realizes she got more than she bargained for. As their secret affair evolves, Lev wonders: Does their forbidden romance really have a chance?'
    }
  },
  resultHeader: 'Your Perfect Story Is...',
  resultSlides: [
    {
      text: 'Hundreds of Sexy audio stories',
      image: '/images/loading-slide-1.png'
    },
    {
      text: 'Sleep stories and sounds',
      image: '/images/loading-slide-2.png'
    },
    {
      text: 'Intimate wellness guides',
      image: '/images/loading-slide-3.png'
    }
  ]
})

export const fantasyQuizCopy: Readonly<QuizDataType> = Object.freeze<QuizDataType>({
  quiz: [
    {
      index: 0,
      icon: QUIZ_ICONS.lips,
      iconAlt: 'kiss icon',
      questionText: 'I want to be kissed...',
      answers: [
        {
          index: 0,
          text: `Passionately, like they can't get enough`,
          outcomes: [FANTASY.a, FANTASY.b]
        },
        {
          index: 1,
          text: `Gently, with a smile on their face`,
          outcomes: [FANTASY.b, FANTASY.c]
        },
        {
          index: 2,
          text: `Secretly, like's it's something just for us`,
          outcomes: [FANTASY.d, FANTASY.b]
        }
      ]
    },
    {
      index: 1,
      icon: QUIZ_ICONS.thought,
      iconAlt: 'thought icon',
      questionText: `I'm craving...`,
      answers: [
        {
          index: 0,
          text: `Epic romance`,
          outcomes: [FANTASY.a, FANTASY.b]
        },
        {
          index: 1,
          text: `Stolen glances`,
          outcomes: [FANTASY.b, FANTASY.c]
        },
        {
          index: 2,
          text: `Deep longing`,
          outcomes: [FANTASY.d, FANTASY.b]
        }
      ]
    },
    {
      index: 2,
      icon: QUIZ_ICONS.flame,
      iconAlt: 'fire icon',
      questionText: 'I want a connection that is...',
      answers: [
        {
          index: 0,
          text: `Secret & Sneaky`,
          outcomes: [FANTASY.a, FANTASY.b]
        },
        {
          index: 1,
          text: `Spontaneous & Spicy`,
          outcomes: [FANTASY.b, FANTASY.c]
        },
        {
          index: 2,
          text: `Sweet & Sensual`,
          outcomes: [FANTASY.d, FANTASY.b]
        }
      ]
    },
    {
      index: 3,
      icon: QUIZ_ICONS.mic,
      iconAlt: 'microphone icon',
      questionText: 'I\'d love to hear... ',
      answers: [
        {
          index: 0,
          text: '"There\'s power in letting go"',
          outcomes: [FANTASY.a, FANTASY.b]
        },
        {
          index: 1,
          text: '"You occupy my thoughts night and day"',
          outcomes: [FANTASY.b, FANTASY.c]
        },
        {
          index: 2,
          text: '"You turn me into something animal. I feel feral"',
          outcomes: [FANTASY.d, FANTASY.b]
        }
      ]
    },
    {
      index: 4,
      icon: QUIZ_ICONS.heart,
      iconAlt: 'heart icon',
      questionText: 'My favorite romance trope is...',
      answers: [
        {
          index: 0,
          text: 'The ~bad boy/girl~',
          outcomes: [FANTASY.a, FANTASY.b]
        },
        {
          index: 1,
          text: 'Forbidden lovers',
          outcomes: [FANTASY.b, FANTASY.c]
        },
        {
          index: 2,
          text: 'Friends to lovers',
          outcomes: [FANTASY.d, FANTASY.b]
        }
      ]
    },
    {
      index: 5,
      icon: QUIZ_ICONS.couple,
      iconAlt: 'double heart icon',
      questionText: "I'm interested in...",
      genderPref: true,
      answers: [
        {
          index: 0,
          text: 'Straight romance',
          genderPrefText: 'Men',
          outcomes: [FANTASY.a, FANTASY.c, FANTASY.d]
        },
        {
          index: 1,
          text: 'Queer romance',
          genderPrefText: 'Women',
          outcomes: [FANTASY.b]
        },
        {
          index: 2,
          text: 'all romance',
          genderPrefText: 'Both',
          outcomes: [FANTASY.a, FANTASY.b, FANTASY.c, FANTASY.d]
        }
      ]
    }
  ],
  tieBreakers: [
    {
      index: 0,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'Last question! Give me a story with...',
      vs: [FANTASY.a, FANTASY.b],
      answers: [
        {
          index: 0,
          text: 'Greek Gods & Goddesses',
          outcomes: [FANTASY.a]
        },
        {
          index: 1,
          text: 'Historical Romance',
          outcomes: [FANTASY.b]
        }
      ]
    },
    {
      index: 1,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'Last question! Give me a story with...',
      vs: [FANTASY.b, FANTASY.c],
      answers: [
        {
          index: 0,
          text: 'Forbidden Lovers',
          outcomes: [FANTASY.c]
        },
        {
          index: 1,
          text: 'Friends to lovers',
          outcomes: [FANTASY.b]
        }
      ]
    },
    {
      index: 2,
      icon: QUIZ_ICONS.star,
      type: 'tiebreaker',
      iconAlt: 'star icon',
      questionText: 'Last question! Give me a story with...',
      vs: [FANTASY.b, FANTASY.d],
      answers: [
        {
          index: 0,
          text: 'Vampires',
          outcomes: [FANTASY.d]
        },
        {
          index: 1,
          text: 'Historical Romance',
          outcomes: [FANTASY.b]
        }
      ]
    }
  ],
  results: {
    [FANTASY.a]: {
      id: '-NSlWiHbZKt-EMpnlVfW',
      image: DipseaContentfulAssets.quiz_fantasy_forbidden_fruit,
      genderPref: 'Men',
      display_name: FANTASY.a,
      description: 'When Persephone meets Hades, she’s living a charmed life as the Goddess of Spring on Mount Olympus. But when he gives her a taste of the dark freedoms she’s missing, she can’t resist what he and the Underworld have to offer. In secret, they explore the outer bounds of her pleasure while trying to avoid the ire of the gods.'
    },
    [FANTASY.b]: {
      id: '-NW41qJ7A529VWR3XLHe',
      image: DipseaContentfulAssets.quiz_fantasy_close_companions,
      genderPref: 'Women',
      display_name: FANTASY.b,
      description: 'A thoroughly modern take on queer romance in the Regency era. Charlotte and Willa are young women on the cusp of being presented to society, yet neither is particularly interested in the life that’s expected of them. When they’re paired for painting lessons, they find kinship in their shared independent streak and pay more attention to each other than the feminine arts. As they grow closer, they get bolder in the risks they’ll take to be together…'
    },
    [FANTASY.c]: {
      id: '-NMW1K74E687LyQTQ6qT',
      image: DipseaContentfulAssets.quiz_fantasy_courted,
      genderPref: 'Men',
      display_name: FANTASY.c,
      description: 'A reimagining of historical romance that\'s a little less buttoned up. It’s the social season in 19th century England, and Elizabeth Everly’s parents want her to marry Oliver Ainsworth, an uptight man of society she can’t stand. So she rebels by pursuing a forbidden relationship with a rough-around-the-edges Irish farmhand. She’s under no illusions that she’ll be marrying for love, but her affair with Ewan ignites a journey of sexual exploration that makes it harder to follow the expected path.'
    },
    [FANTASY.d]: {
      id: '-NCvR-TOkdB_anJyANs9',
      image: DipseaContentfulAssets.quiz_fantasy_night_school,
      genderPref: 'Men',
      display_name: FANTASY.d,
      description: 'When Helena starts working for the mysterious Professor Whitlock, their chemistry is intense. But strange events make her wonder…could he be a vampire?'
    }
  },
  resultHeader: 'Your Perfect Story Is...',
  resultSlides: [
    {
      text: 'Hundreds of Sexy audio stories',
      image: '/images/loading-slide-1.png'
    },
    {
      text: 'Sleep stories and sounds',
      image: '/images/loading-slide-2.png'
    },
    {
      text: 'Intimate wellness guides',
      image: '/images/loading-slide-3.png'
    }
  ]
})
